import { useTenant } from '@context/TenantProvider';
import { apiRoute } from '@helpers/envHelper';
import { alpha, Box, Card, CustomTheme, Stack, useTheme } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router';

export const GuestLayout: React.FC = (): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const tenant = useTenant();

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      sx={{
        height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
        minHeight: '100%',
        minWidth: theme.breakpoints.values.xs,
        [theme.breakpoints.down('mobile')]: {
          display: 'block',
          pt: '20px',
        },
        backgroundImage: `url('${apiRoute(tenant?.theme.questLayout?.backgroundImage)}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: alpha('#FFF', 0.2),
          backdropFilter: 'blur(3px)',
          zIndex: 0,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'center',
          width: '100%',
          margin: 'auto',
          maxWidth: '450px',
          zIndex: 1,
        }}
      >
        <Box
          component="img"
          src={apiRoute(tenant?.theme.questLayout?.logo)}
          sx={{
            width: { xs: '300px', md: '400px' },
            mx: 'auto',
            mb: '20px',
          }}
        />

        <Card
          variant="outlined"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: '15px',
            gap: '10px',
            boxShadow:
              'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
          }}
        >
          <Outlet />
        </Card>
      </Box>
    </Stack>
  );
};
